<!--
  表单的提交按钮栏

  使用：
  <lc-form-button-bar>
    <el-button />
  </lc-form-button-bar>
 -->
<template>
  <div class="lc-form-button-bar" :style="componentStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 菜单是否收起
     *
     * @returns {boolean} 是否收起
     */
    isMenuCollapse() {
      // 直接读取 state
      return this.$store.state.menu.isCollapse
    },
    /**
     * 组件的样式
     *
     * @returns {string} style 样式
     */
    componentStyle() {
      let position = this.isMenuCollapse ? '65px' : '150px'

      return { left: position }
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-form-button-bar {
  position: fixed;
  bottom: 0px;
  right: 9px;
  background-color: #fafafa;
  opacity: 0.89;
  box-shadow: inset 0 3px 3px #eee;
  z-index: 1000;
  padding: 15px 0px 30px 150px;
}
</style>
